import { buildODataQuery } from "@sg-protect/core";
import { queryOptions } from "../../client.ts";
import type {
    ODataSiteCollectionODataCollectionResponse,
    ODataUser,
    ODataUserODataCollectionResponse
} from "../../types.ts";

const SEARCHABLE_TYPES_FILTER =
    "types/any(t: t eq 'group' or t eq 'oneDrive' or t eq 'sharePointSite' or t eq 'teams')";

export const MIN_USER_SEARCH_TERM_LENGTH = 3;

export type ODataUserSearchResult = Pick<ODataUser, "id" | "jobTitle" | "email" | "type" | "isEnabled"> & {
    displayName: string;
};

export function searchSiteCollectionsQueryOptions(term: string) {
    const query = buildODataQuery({
        select: ["id", "displayName", "types"],
        orderby: { field: "displayName", direction: "asc" },
        filter: SEARCHABLE_TYPES_FILTER,
        search: term,
        top: 25,
        count: false
    });

    return queryOptions(
        "get",
        "/bff/odata/siteCollections",
        { params: { query } },
        {
            enabled: term.length >= 1,
            select: (data: ODataSiteCollectionODataCollectionResponse) => data.value ?? []
        }
    );
}

export function searchUsersQueryOptions(term: string, filter?: string) {
    const query = buildODataQuery({
        select: ["id", "displayName", "jobTitle", "email", "type", "isEnabled"],
        orderby: { field: "displayName", direction: "asc" },
        filter,
        search: term,
        top: 25,
        count: false
    });

    return queryOptions(
        "get",
        "/bff/odata/users",
        { params: { query } },
        {
            enabled: term.length >= MIN_USER_SEARCH_TERM_LENGTH,
            select: (data: ODataUserODataCollectionResponse): ODataUserSearchResult[] =>
                (data.value ?? []).flatMap(user =>
                    user.displayName ? [{ ...user, displayName: user.displayName }] : []
                )
        }
    );
}
